import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NipWorkerFieldsService {
  /**
   * * Table header
   */
  tableHeader = [
    {
      field: 'batch',
      header: 'Šarža br',
    },
    {
      field: 'productBatch',
      header: 'Šifra proizvoda',
    },
    {
      field: 'productName',
      header: 'Naziv proizvoda',
    },
    {
      field: 'required_units',
      header: 'Količina proizvoda',
    },
    {
      field: 'deadline',
      header: 'Rok za izradu',
    },
    {
      field: 'workNipStatus',
      header: 'Status',
    },
  ];
  constructor() {}
}
